function UsersSection({
  privilegesLoading,
  myPrivileges,
  usersMessage,
  handleCreateUser,
  userForm,
  handleUserInputChange,
  usersSubmitting,
  privilegesMessage,
  privilegeUsers,
  privilegeUsersLoading,
  privilegesSubmitting,
  handleToggleAdminPrivilege,
}) {
  return (
    <section className="users-admin-block">
      <div className="section-header">
        <h2>Manage Users</h2>
      </div>

      <p className="users-helper-text">
        Create a new admin login using email and password.
      </p>

      {usersMessage && <p className="status-text">{usersMessage}</p>}

      {privilegesLoading && <p className="status-text">Checking permissions...</p>}

      {!privilegesLoading && !myPrivileges.admin && (
        <p className="status-text">Only admins can create users.</p>
      )}

      {!privilegesLoading && myPrivileges.admin && (
        <form className="user-create-form" onSubmit={handleCreateUser}>
          <label htmlFor="new-user-email">Email</label>
          <input
            id="new-user-email"
            type="email"
            name="email"
            value={userForm.email}
            onChange={handleUserInputChange}
            placeholder="owner@example.com"
            autoComplete="email"
            required
          />

          <label htmlFor="new-user-password">Password</label>
          <input
            id="new-user-password"
            type="password"
            name="password"
            value={userForm.password}
            onChange={handleUserInputChange}
            placeholder="Minimum 8 characters"
            autoComplete="new-password"
            minLength={8}
            required
          />

          <label htmlFor="new-user-confirm-password">Repeat Password</label>
          <input
            id="new-user-confirm-password"
            type="password"
            name="confirmPassword"
            value={userForm.confirmPassword}
            onChange={handleUserInputChange}
            placeholder="Repeat password"
            autoComplete="new-password"
            minLength={8}
            required
          />

          <button type="submit" disabled={usersSubmitting}>
            {usersSubmitting ? 'Creating User...' : 'Create User'}
          </button>
        </form>
      )}

      <div className="user-privileges-panel">
        <h3>Admin Privileges</h3>
        <p className="users-helper-text">
          Main admin can grant or revoke admin rights for an existing user.
        </p>

        {privilegesMessage && <p className="status-text">{privilegesMessage}</p>}

        {!myPrivileges.canManagePrivileges && (
          <p className="status-text">Only the main admin can update privileges.</p>
        )}

        {myPrivileges.canManagePrivileges && (
          <div className="privilege-users-list">
            {privilegeUsersLoading && <p className="status-text">Loading users...</p>}

            {!privilegeUsersLoading && privilegeUsers.length === 0 && (
              <p className="status-text">No users found.</p>
            )}

            {!privilegeUsersLoading &&
              privilegeUsers.map((user) => (
                <div className="privilege-user-row" key={user.uid}>
                  <div>
                    <p className="privilege-user-email">{user.email || 'No email set'}</p>
                    <p className="privilege-user-meta">
                      {user.mainAdmin ? 'Main Admin' : user.admin ? 'Admin' : 'Standard User'}
                    </p>
                  </div>

                  <button
                    type="button"
                    className={user.admin ? 'sold-btn' : 'available-btn'}
                    onClick={() => handleToggleAdminPrivilege(user)}
                    disabled={privilegesLoading || privilegesSubmitting || user.mainAdmin}
                    title={user.mainAdmin ? 'Main admin access cannot be changed here.' : undefined}
                  >
                    {privilegesSubmitting
                      ? 'Updating...'
                      : user.mainAdmin
                        ? 'Main Admin'
                        : user.admin
                          ? 'Revoke Admin'
                          : 'Make Admin'}
                  </button>
                </div>
              ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default UsersSection;
